import { render } from "./editsalesreturns.vue?vue&type=template&id=da1fc34a"
import script from "./editsalesreturns.vue?vue&type=script&lang=js"
export * from "./editsalesreturns.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GigLabs\\CIMS\\CIMS-AfyunProd\\gig.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__